<template>
  <v-container v-if="currentUser">
    <v-row align="center" no-gutters justify="center">
      <v-spacer></v-spacer>
      <v-col cols="10">
        <v-card>
          <v-expansion-panels multiple v-model="expandedPanelIndex">
            <div
              :class="`${
                acceptedTermsAndConditions
                  ? 'expansion-panel-border-green'
                  : 'expansion-panel-border-red'
              }`"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h3
                    :class="`${
                      acceptedTermsAndConditions
                        ? 'green--text'
                        : 'primary--text'
                    } pl-2 pt-3 pb-3`"
                  >
                    Terms and conditions
                  </h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-title primary-title class="pt-0">
                    <div
                      class="pl-3 pr-3 pt-1 pb-3 container"
                      v-html="termsAndConditions.content"
                    ></div>
                    <v-btn
                      class="ml-3"
                      outlined
                      color="primary"
                      @click.stop="acceptTerms(termsAndConditions.filename)"
                    >
                      Accept terms
                    </v-btn>
                  </v-card-title>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              :class="`${
                acceptedRgpd
                  ? 'expansion-panel-border-green'
                  : 'expansion-panel-border-red'
              }`"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h3
                    :class="`${
                      acceptedRgpd ? 'green--text' : 'primary--text'
                    } pl-2 pt-3 pb-3`"
                  >
                    GDPR Agreement
                  </h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-title primary-title class="pt-0">
                    <div
                      class="pl-3 pr-3 pt-1 pb-3 container"
                      v-html="rgpd.content"
                    ></div>
                    <v-btn
                      class="ml-3"
                      outlined
                      color="primary"
                      @click.stop="acceptRgpd(rgpd.filename)"
                    >
                      Accept GDPR
                    </v-btn>
                  </v-card-title>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
          </v-expansion-panels>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import navigationComponents from '../components/navigationComponents'
import errorMixin from '../mixins/logHandler'

export default {
  name: 'Conditions',

  mixins: [errorMixin],

  mounted() {
    this.init()
    this.expandedPanelIndex = 0
  },

  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },

  data() {
    return {
      termsAndConditions: { content: '', filename: null },
      rgpd: { content: '', filename: null },
      acceptedTermsAndConditions: false,
      acceptedRgpd: false,
      acceptedTermsAndConditionsInitial: true,
      acceptedRgpdInitial: true,
      expandedPanelIndex: 0
    }
  },
  watch: {
    acceptedTermsAndConditions(val) {
      if (this.acceptedTermsAndConditions && this.acceptedRgpd) {
        this.$router.push('/missions')
      }
    },
    acceptedRgpd(val) {
      if (this.acceptedTermsAndConditions && this.acceptedRgpd) {
        this.$router.push('/missions')
      }
    }
  },

  methods: {
    termsAndConditionsMethod() {
      this.termsAndConditions =
        navigationComponents.readFormattedTermsAndCondition(this.currentUser)
    },

    rgpdMethod() {
      this.rgpd = navigationComponents.readFormattedRGPD()
    },

    async init() {
      this.termsAndConditionsMethod()
      let currentConditionsFilename = this.termsAndConditions.filename
      this.rgpdMethod()
      let currentRgpdFilename = this.rgpd.filename

      try {
        let resCdts = await this.$http.get(
          `/users/${this.currentUser.id}/conditions`
        )
        let resRgpd = await this.$http.get(`/users/${this.currentUser.id}/rgpd`)

        // Conditions testing
        this.acceptedTermsAndConditionsInitial = resCdts.data.includes(
          currentConditionsFilename
        )
        this.acceptedRgpdInitial = resRgpd.data.includes(currentRgpdFilename)
        this.acceptedTermsAndConditions = this.acceptedTermsAndConditionsInitial
        this.acceptedRgpd = this.acceptedRgpdInitial
        if (!this.acceptedTermsAndConditions && !this.acceptedRgpd) {
          this.expandedPanelIndex = 0
        } else if (this.acceptedTermsAndConditions && !this.acceptedRgpd) {
          this.expandedPanelIndex = 1
        } else {
          this.expandedPanelIndex = 0
        }
      } catch (e) {
        this.displayMessage(
          'Network error while trying to retrieve conditions and RGPD.',
          e,
          'notification',
          'error'
        )
      }
    },
    async acceptTerms(filename) {
      if (filename !== null || filename) {
        await this.$http
          .post(`/users/${this.currentUser.id}/conditions`, filename)
          .catch((e) => {
            this.displayMessage(
              'Network error while trying to accept conditions.',
              e,
              'notification',
              'error'
            )
          })
      }
      this.acceptedTermsAndConditions = true
      this.expandedPanelIndex = -1
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          offset: 0,
          easing: 'easeInOutCubic',
          duration: 0
        })
      }, 500)
      if (!this.acceptedRgpd) {
        this.expandedPanelIndex = 1
      }
    },
    async acceptRgpd(filename) {
      if (filename !== null || filename) {
        await this.$http
          .post(`/users/${this.currentUser.id}/rgpd`, filename)
          .catch((e) => {
            this.displayMessage(
              'Network error while trying to accept RGPD agreement.',
              e,
              'notification',
              'error'
            )
          })
      }
      this.acceptedRgpd = true
    }
  }
}
</script>
<style>
.expansion-panel-border-green {
  border: solid;
  border-color: #66bb6a;
  border-radius: 2px;
  width: 100%;
}
.expansion-panel-border-red {
  width: 100%;
}
</style>
